import * as types from '../mutation-types'
import api from '@/api/hireRequest'
import router from "@/router";

// initial state
const state = {
    hireRequest: [],
    loaded: false,
}

const getters = {
    hireRequest: state => state.hireRequest,
    hireRequestLoaded: state => state.loaded,
}

const actions = {
    getHireRequest({ commit }, payload) {
        commit(types.SET_HIRE_REQUEST_LOADED, false );
        api.getHireRequest(payload, (response) => {
            if(!response._embedded.HireRequest[0]) {
                router.push('/404')
            }
            commit(types.SET_HIRE_REQUEST, response._embedded.HireRequest[0] );
            commit(types.SET_HIRE_REQUEST_LOADED, true );
        })
    },
    cleanHireRequests({commit}) {
        commit(types.SET_HIRE_REQUEST_LOADED, false );
        commit(types.SET_HIRE_REQUEST, {} );
    }
}

const mutations = {
    [types.SET_HIRE_REQUEST] (state, hireRequest ) {
        state.hireRequest = hireRequest
    },
    [types.SET_HIRE_REQUEST_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


